import { TFAData } from '../utils/types';
import { emptySplitApi } from './emptySplitApi';
import { createTokenHeader } from '../utils/functions/headers';

export const faService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['faList'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      addUpdateFADetails: builder.mutation<void, TFAData>({
        query: (data) => {
          return {
            url: 'pincode/fa-mapping',
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['faList'],
      }),
      getFADetails: builder.query<TFAData, string>({
        query: (faId) => ({
          method: 'GET',
          url: `pincode/fa-mapping/${Number(faId)}`,
        }),
      }),
      getFAListForPlant: builder.query<
        TFAData[],
        number | string
      >({
        query: (plant) => ({
          method: 'GET',
          url: `fa/list/depo/${plant}`,
        }),
      }),
      importFA: builder.mutation({
        query: ({ data, companyId }) => ({
          url: `pincode/fa-mapping/import/${companyId}`,
          method: 'POST',
          data: data,
          headers: createTokenHeader(),
        }),
        invalidatesTags: ['faList'],
      }),
    }),
  });

export const {
  useAddUpdateFADetailsMutation,
  useGetFADetailsQuery,
  useGetFAListForPlantQuery,
  useImportFAMutation,
} = faService;
